var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
(() => {
    angular.module('QMC.Holiday', []).config(routes);
    routes.$inject = ['$locationProvider', '$stateProvider', '$urlRouterProvider', 'qmcBase'];
    function routes($locationProvider, $stateProvider, $urlRouterProvider, qmcBase) {
        $locationProvider.html5Mode({
            enabled: false,
            requireBase: false
        });
        $stateProvider
            .state('holiday', {
            url: '/holiday',
            templateUrl: qmcBase + '/Holiday',
            controller: 'HolidayListController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Holiday List');
                    }]
            }
        })
            .state('holidayDetail', {
            url: '/holiday/:id',
            templateUrl: qmcBase + '/Holiday',
            controller: 'HolidayListController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Holiday Detail');
                    }]
            }
        });
    }
})();
var QMC;
(function (QMC) {
    var Holiday;
    (function (Holiday) {
        class HttpProvider {
            static configureHttpProvider($httpProvider) {
                // initialize get if not there
                if (!$httpProvider.defaults.headers.get) {
                    $httpProvider.defaults.headers.get = {};
                }
                // disable IE ajax request caching
                $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
                // extra
                $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
                $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
            }
        }
        Holiday.HttpProvider = HttpProvider;
    })(Holiday = QMC.Holiday || (QMC.Holiday = {}));
})(QMC || (QMC = {}));
(() => {
    angular.module('QMC.Holiday')
        .config(['$httpProvider', QMC.Holiday.HttpProvider.configureHttpProvider]);
})();
var QMC;
(function (QMC) {
    var Holiday;
    (function (Holiday) {
        let HolidayService = class HolidayService extends QMC.Common.BaseService {
            constructor($http, $q) {
                super($http, $q);
                this.$http = $http;
                this.$q = $q;
                this.modulePath = '/Holiday';
            }
            getHolidayWv() {
                return super.getItem(this.modulePath + '/WvModel', {}, (data) => {
                    return data;
                });
            }
            getHoliday(id) {
                return super.getItem(this.modulePath + "/" + id, {}, (data) => {
                    return data;
                });
            }
            getHolidayInfo(date) {
                if (date)
                    date = moment(date).startOf('day').toDate();
                return super.getItem(this.modulePath + "/info", { date: date }, (data) => {
                    return data;
                });
            }
            getHolidayLock() {
                return super.getItem(this.modulePath + "/Lock", {}, (data) => {
                    return data;
                });
            }
            getHolidayRequiredFields() {
                return super.getItem(this.modulePath + "/RequiredFields", {}, (data) => {
                    return data;
                });
            }
            getHolidayList(dateFrom, dateTo) {
                return super.get(this.modulePath, { dateFrom: dateFrom, dateTo: dateTo }, (data) => {
                    return data;
                });
            }
            postHoliday(data) {
                return super.post(this.modulePath, data).then((data) => {
                    return data;
                });
            }
            putHoliday(id, data) {
                return super.put(this.modulePath + "/" + id, data).then((data) => {
                    return data;
                });
            }
            deleteHoliday(id) {
                return super.delete(this.modulePath + "/" + id).then((data) => {
                    return data;
                });
            }
            calculateDayValues(dateFrom, dateTo, referenceId) {
                return super.post("/Roster/Service/CalculateDayValues", { dateFrom, dateTo, referenceId }).then((data) => {
                    return data;
                });
            }
            checkForWarningsAndErrors(data) {
                return super.post(this.modulePath + "/WarningsAndErrors", data).then((data) => {
                    return data;
                });
            }
        };
        HolidayService = __decorate([
            QMC.Service('QMC.Holiday', 'HolidayService'),
            QMC.Inject('$http', '$q')
        ], HolidayService);
        Holiday.HolidayService = HolidayService;
    })(Holiday = QMC.Holiday || (QMC.Holiday = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Holiday;
    (function (Holiday) {
        /**
         * Holiday UserInterface class
         *
         * @export
         * @class UserInterface
         * @extends {Common.UserInterface}
         */
        class UserInterface extends QMC.Common.UserInterface {
            constructor() {
                super(...arguments);
                this.showMonthFilter = true;
                /**
                 * Holiday list table
                 * @memberOf UserInterface
                 */
                this.listTable = {
                    "config": {
                        "defaultSort": "dateFrom",
                        "sortReverse": "true",
                    },
                    "filter": {
                        model: null
                    },
                    "table": {
                        "Farbe": {
                            "label": "color",
                            "dType": "Color"
                        },
                        "Bezeichnung": {
                            "label": "caption",
                            "dType": "string",
                            "lngTag": "20000053"
                        },
                        "Genehmigungsstatus": {
                            "label": "approved",
                            "dType": "string",
                            "lngTag": "20020007"
                        },
                        "Länge": {
                            "label": "holidayDuration",
                            "dType": "string",
                            "lngTag": "20020032"
                        },
                        "Datum von": {
                            "label": "dateFrom",
                            "dType": "Date",
                            "lngTag": "20000047"
                        },
                        "Datum bis": {
                            "label": "dateTo",
                            "dType": "Date",
                            "lngTag": "20000054"
                        },
                        "Art": {
                            "label": "serviceType",
                            "dType": "string",
                            "lngTag": "20020008"
                        },
                        "Aktionen": [
                            {
                                "icon": "qm-icon-eye blue",
                                "click": "editHoliday",
                                "openModal": "true",
                                "dType": "Button",
                                "tooltip": "Ansehen",
                                "lngTag": "20000141",
                                "events": {
                                    "hide": "allowEdit"
                                },
                            },
                            {
                                "icon": "qm-icon-pencil blue",
                                "click": "editHoliday",
                                "dType": "Button",
                                "openModal": "true",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "events": {
                                    "hide": "!allowEdit"
                                },
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteHoliday",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "events": {
                                    "hide": "!allowDelete"
                                },
                                "permission": "delete"
                            }, {
                                "icon": "qm-icon-note_text darkslategray",
                                "click": "toggleCommentModal",
                                "label": "Comment",
                                "dType": "Button",
                                "events": {
                                    "hide": "!viewComment",
                                },
                                "tooltip": "Bemerkung",
                                "lngTag": "20000049",
                            }
                        ]
                    }, "card": {
                        "avatar": {
                            "icon": "qm-icon-palm_tree"
                        },
                        "text": {
                            "label": "caption",
                            "dType": "string"
                        },
                        "subtext": [
                            {
                                "label": "serviceType",
                                "dType": "string"
                            },
                            {
                                "label": "holidayDuration",
                                "dType": "string"
                            },
                            {
                                "label": "dateFrom",
                                "dType": "Date"
                            },
                            {
                                "label": "dateTo",
                                "dType": "Date"
                            },
                            {
                                "prefix": "Genehmigung: ",
                                "label": "approved",
                                "dType": "string"
                            }
                        ],
                        "buttons": [
                            {
                                "icon": "qm-icon-pencil blue",
                                "click": "editHoliday",
                                "openModal": "true",
                                "targetModal": "#edit-form",
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify",
                                "events": {
                                    "hide": "!allowEdit"
                                },
                            },
                            {
                                "icon": "qm-icon-eye blue",
                                "click": "editHoliday",
                                "openModal": "true",
                                "targetModal": "#edit-form",
                                "dType": "Button",
                                "tooltip": "Ansehen",
                                "lngTag": "20000141",
                                "events": {
                                    "hide": "allowEdit"
                                },
                            },
                            {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteHoliday",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete",
                                "events": {
                                    "hide": "!allowDelete"
                                },
                            },
                            {
                                "icon": "qm-icon-note_text darkslategray",
                                "click": "toggleCommentModal",
                                "label": "Comment",
                                "dType": "Button",
                                "events": {
                                    "hide": "!viewComment",
                                },
                                "tooltip": "Bemerkung",
                                "lngTag": "20000049",
                            }
                        ]
                    },
                    "data": null,
                };
                this.holidayForm = {
                    form: [
                        {
                            placeholder: "Urlaubsart auswählen",
                            label: "Urlaubsart",
                            type: "Select2",
                            required: true,
                            model: "isSpecialHoliday",
                            lngTag: 20020008,
                            dataSource: "getHolidayCategoryList",
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                            events: {
                                updateDataSource: "holidayTypeId",
                            },
                            validate: {
                                message: "Bitte die Urlaubsart auswählen.",
                                messageTag: 21003019
                            },
                        },
                        {
                            placeholder: "Urlaubsunterart auswählen",
                            label: "Urlaubsart",
                            type: "Select2",
                            required: true,
                            model: "holidayTypeId",
                            lngTag: 20020020,
                            dataSource: "getHolidayTypeList",
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                            validate: {
                                message: "Bitte die Urlaubsunterart auswählen.",
                                messageTag: 21003021
                            },
                            events: {
                                hideExpression: "qmForm.isSpecialHoliday"
                            },
                            id: "holidayTypeId",
                            wvId: '827662a9-b386-4546-9f8e-cc52e896c336',
                            wvListData: 'wvList.holidayTypeWvList',
                            wvValueType: 'color'
                        },
                        {
                            placeholder: "Urlaubsunterart auswählen",
                            label: "Urlaubsart",
                            type: "Select2",
                            required: true,
                            model: "holidayTypeId",
                            lngTag: 20020020,
                            dataSource: "getSpecialHolidayTypeList",
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                            validate: {
                                message: "Bitte die Urlaubsunterart auswählen.",
                                messageTag: 21003021
                            },
                            events: {
                                hideExpression: "!qmForm.isSpecialHoliday"
                            },
                            wvId: '4dd3f89a-2cdd-49fb-8d11-0be9f8ea3431',
                            wvListData: 'wvList.specialHolidayTypeWvList',
                            wvValueType: 'color'
                        },
                        {
                            label: "Genehmigungsstatus",
                            type: "Select",
                            dataSource: "getApprovementWvList",
                            model: "approvedId",
                            lngTag: 20020007,
                            events: {
                                hideExpression: "!qmForm.permissionApproved"
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                                icon: "qm-icon-information"
                            }
                        },
                        {
                            label: "Genehmigungsstatus",
                            type: "Select",
                            dataSource: "getApprovementWvList",
                            model: "approvedId",
                            lngTag: 20020007,
                            disabled: true,
                            events: {
                                hideExpression: "qmForm.permissionApproved"
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                                icon: "qm-icon-information"
                            }
                        },
                        {
                            type: "hr"
                        },
                        {
                            label: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis",
                            },
                            placeholder: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis"
                            },
                            type: "DateRange",
                            lngTag: {
                                dateFrom: 20000047,
                                dateTo: 20000054
                            },
                            model: {
                                dateFrom: "dateFrom",
                                dateTo: "dateTo"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayDateTo: true,
                                dateFromNotRequired: false,
                                dateToRequired: true
                            }
                        },
                        {
                            type: "Loading",
                            style: {
                                class: "col-xs-12"
                            },
                            events: {
                                hideExpression: "!qmScopeCallback().loadingDayCalc"
                            }
                        },
                        {
                            label: "Anzahl Tage",
                            type: "CheckboxInline",
                            lngTag: 20020026,
                            model: "isManualDays",
                            id: "isManualDays",
                            style: {
                                class: "col-md-2 col-sm-3 col-xs-6"
                            },
                            events: {
                                hideExpression: "qmScopeCallback().loadingDayCalc"
                            }
                        },
                        {
                            model: "amountOfDays",
                            type: "Number",
                            disabled: true,
                            id: "amountOfDaysDis",
                            style: {
                                class: "col-md-2 col-sm-3 col-xs-6",
                            },
                            events: {
                                hideExpression: "qmScopeCallback().loadingDayCalc || qmForm.isManualDays"
                            }
                        },
                        {
                            model: "amountOfDays",
                            type: "Number",
                            disabled: false,
                            id: "amountOfDays",
                            style: {
                                class: "col-md-2 col-sm-3 col-xs-6",
                            },
                            events: {
                                hideExpression: "qmScopeCallback().loadingDayCalc || !qmForm.isManualDays"
                            }
                        },
                        {
                            label: "Anzahl Stunden",
                            type: "CheckboxInline",
                            lngTag: 20020027,
                            model: "isManualHours",
                            id: "isManualHours",
                            style: {
                                class: "col-md-2 col-sm-3 col-xs-6"
                            },
                            events: {
                                hideExpression: "qmScopeCallback().loadingDayCalc"
                            }
                        },
                        {
                            model: "amountOfHours",
                            type: "Number",
                            disabled: true,
                            id: "amountOfHoursDis",
                            style: {
                                class: "col-md-2 col-sm-3 col-xs-6"
                            },
                            events: {
                                hideExpression: "qmScopeCallback().loadingDayCalc || qmForm.isManualHours"
                            }
                        },
                        {
                            model: "amountOfHours",
                            type: "Number",
                            disabled: false,
                            id: "amountOfHours",
                            style: {
                                class: "col-md-2 col-sm-3 col-xs-6"
                            },
                            events: {
                                hideExpression: "qmScopeCallback().loadingDayCalc || !qmForm.isManualHours"
                            }
                        },
                        {
                            label: "Dienste anrechnen",
                            type: "CheckboxInline",
                            lngTag: 20020024,
                            model: "creditWorkAsHoliday",
                            id: "creditWorkAsHoliday",
                            style: {
                                class: "col-md-4 col-xs-12"
                            }
                        },
                        {
                            type: "hr"
                        },
                        {
                            label: "Anzeigefarbe",
                            type: "Color",
                            lngTag: 20020034,
                            model: "color",
                            style: {
                                class: "col-md-12 col-xs-12",
                                icon: "qm-icon-painters_palette"
                            },
                            disabled: true
                        },
                        {
                            placeholder: "Bemerkung eintragen...",
                            label: "Bemerkung",
                            type: "Textarea",
                            maxLength: -1,
                            lngTag: 20000049,
                            model: "comment",
                            required: false,
                            style: {
                                class: "col-md-12 col-xs-12",
                            },
                        },
                    ],
                    actions: {
                        put: "putHoliday",
                        post: "addHoliday",
                        delete: "deleteHoliday"
                    }
                };
            }
        }
        Holiday.UserInterface = UserInterface;
    })(Holiday = QMC.Holiday || (QMC.Holiday = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Holiday;
    (function (Holiday) {
        let HolidayListController = class HolidayListController {
            /**
             * Creates an instance of HolidayListController.
             * @param {HolidayService} holidayService
             * @param {any} $qui
             * @param {ng.IScope} $scope
             * @param {any} $stateParams
             * @param {any} $state
             * @param {Common.QmcLanguageService} lng
             * @param {*} userService
             * @param {Common.QmcPermissionService} permissionService
             *
             * @memberof HolidayListController
             */
            constructor(holidayService, $qui, $scope, $sce, $stateParams, $state, lng, userService, permissionService, $location) {
                this.holidayService = holidayService;
                this.$qui = $qui;
                this.$scope = $scope;
                this.$sce = $sce;
                this.$stateParams = $stateParams;
                this.$state = $state;
                this.lng = lng;
                this.userService = userService;
                this.permissionService = permissionService;
                this.$location = $location;
                this.ui = new Holiday.UserInterface();
                this.allowTableExport = false;
                this.storageName = 'Holiday_' + $('#session').data().userId;
                this.initModal = 'init';
                this.validation = {
                    isLoading: false,
                    errors: [],
                    warnings: [],
                    hours: Number,
                    days: Number
                };
                this.permissions = { standard: undefined, special: undefined, approved: undefined, document: undefined, documentSpecial: undefined };
                this.formDisabled = true;
                this.callbacks = { onNew: () => this.getData(), onEdit: () => this.getData(), onDelete: () => this.getData() };
                this.approvementMap = [];
                this.data = [];
                $qui.init($qui.getSectionColor($location.path()), () => {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                    $qui.navToggle();
                });
                this.contingentDate = new Date();
                this.filter = {
                    dateFrom: moment().startOf('year').toDate(),
                    dateTo: moment().endOf('year').toDate(),
                    approvement: []
                };
                if (document.getElementById("permissions").getAttribute("holiday").toLocaleLowerCase() !== "true") {
                    this.forbidden = true;
                    return;
                }
                this.userService.getUserSettings(["FLS.SHOWMONTHFILTER"]).then((data) => {
                    this.showMonthFilter = data[0].value.toLowerCase() === "true";
                    if (this.showMonthFilter)
                        this.showMonthFilter = "year";
                });
                this.promptOptions = {
                    title: "Urlaubsantrag",
                    yesNo: true,
                    icon: "qm-icon-history2",
                    text: this.lng.translate(20000290, 'Wollen Sie den Eintrag wirklich löschen?')
                };
                this.getWv();
                this.permissionService.getPermissionsByObjectTypes([411003, 411005, 120024, 411016, 411017, 420000]).then((data) => {
                    // if no permission for module access, return
                    if (!data[5].moduleAccess) {
                        this.forbidden = true;
                        return;
                    }
                    this.permissions.standard = data[0];
                    this.allowTableExport = data[0].print;
                    this.permissions.special = data[1];
                    this.new = this.permissions.special.new || this.permissions.standard.new;
                    this.modify = this.permissions.special.modify || this.permissions.standard.modify || this.new;
                    this.delete = this.permissions.special.delete || this.permissions.standard.delete || this.new;
                    this.permissions.approved = data[2];
                    this.permissions.document = data[3];
                    this.permissions.documentSpecial = data[4];
                    this.$qui.getTableAutoload(this.userService).then((ltd) => {
                        this.shouldLoadTableData = ltd;
                        if (this.shouldLoadTableData) {
                            this.getData();
                        }
                        else {
                            this.getHolidayInfo();
                        }
                    });
                    this.init();
                    if (this.$stateParams.id) {
                        this.editHoliday({ objectId: this.$stateParams.id });
                    }
                });
                this.ui.listTable.filter.model = this.tableFilter;
            }
            ////////////////////////// DISPLAYLOGIC //////////////////////////
            /**
             * Init the filter an  the form, with default values
             *
             * @private
             *
             * @memberof HolidayListController
             */
            init() {
                this.$scope.$watch('vm.filter.dateFrom', (newValue, oldValue) => {
                    if (newValue === oldValue)
                        return;
                    this.getData();
                });
                this.$scope.$watch('vm.filter.dateTo', (newValue, oldValue) => {
                    if (newValue === oldValue || this.showMonthFilter)
                        return;
                    this.getData();
                });
                this.$scope.$watch('vm.filter', (newValue, oldValue) => {
                    if (newValue === oldValue)
                        return;
                    QMC.Common.personalLocalStorage.setItem(this.storageName, JSON.stringify(this.filter));
                    this.ui.listTable.data = this.getFilteredData(this.data);
                    this.$qui.functionWaiter("ui.createTable", this);
                }, true);
                this.$scope.$watch('vm.contingentDate', (newValue, oldValue) => {
                    if (!newValue || !oldValue || newValue === oldValue)
                        return;
                    this.getHolidayInfo();
                });
            }
            /**
             * edit an existing holiday
             *
             * @private
             * @param {IHolidayListItem} form
             *
             * @memberof HolidayListController
             */
            editHoliday(form) {
                this.calls.edit(form.objectId);
            }
            getData() {
                this.getHolidayList();
                this.getHolidayInfo();
            }
            allowDataSetEdit(data) {
                return (data.approvedId === QMC.Common.Constants.APPROVAL_PENDING_ID || this.permissions.approved.openFile) && data.permissions.modify;
            }
            getFilteredData(data) {
                let temp = data;
                if (this.filter.approvement.length)
                    temp = temp.filter(x => this.filter.approvement.some(y => y === x.approvedId));
                return temp;
            }
            ////////////////////////// SERVICECALLS //////////////////////////
            /**
             * get the holiday info
             *
             * @private
             *
             * @memberof HolidayListController
             */
            getHolidayInfo() {
                this.infoLoad = true;
                let date = moment(this.contingentDate).endOf('day').toDate();
                //if (date.getFullYear() !== this.filter.dateFrom.getFullYear())
                //    date = moment(date).year(this.filter.dateFrom.getFullYear()).endOf('year').toDate();
                this.holidayService.getHolidayInfo(date).then((data) => {
                    this.infoLoad = false;
                    if (!data) {
                        this.holidayInfo = undefined;
                        return;
                    }
                    data.contingentString = '';
                    if (data.calculatedFrom && data.calculatedUntil)
                        data.contingentString = `${moment(data.calculatedFrom).format('DD.MM.yyyy')} - ${moment(data.calculatedUntil).format('DD.MM.yyyy')}`;
                    if (!data.calculatedFrom && data.calculatedUntil)
                        data.contingentString = `${this.lng.translate(20000048, 'bis')} ${moment(data.calculatedUntil).format('DD.MM.yyyy')}`;
                    if (data.calculatedFrom && !data.calculatedUntil)
                        data.contingentString = `${this.lng.translate(20000067, 'von')} ${moment(data.calculatedFrom).format('DD.MM.yyyy')}`;
                    this.holidayInfo = data;
                });
            }
            /**
             * get a list of all holidays, by date range
             *
             * @private
             *
             * @memberof HolidayListController
             */
            getHolidayList() {
                this.listLoad = true;
                const dateFrom = moment(this.filter.dateFrom).add(3, 'hours').toDate();
                const dateTo = moment(this.filter.dateTo).add(-3, 'hours').toDate();
                this.holidayService.getHolidayList(dateFrom, dateTo).then((data) => {
                    data = data.map((obj) => {
                        obj.allowEdit = this.allowDataSetEdit(obj);
                        obj.allowDelete = (obj.approvedId === QMC.Common.Constants.APPROVAL_PENDING_ID || this.permissions.approved.openFile) && obj.permissions.delete;
                        obj.viewComment = obj.approvedComment && obj.approvedComment !== "";
                        return obj;
                    });
                    this.data = data;
                    this.ui.listTable.data = this.getFilteredData(data);
                    this.listLoad = false;
                    this.$qui.functionWaiter("ui.createTable", this);
                });
            }
            /**
            * show a modal dialog displaying the comment for a holiday entry
            *
            * @private
            * @param {IHoliday} data
            *
            * @memberof HolidayListController
            */
            toggleCommentModal(data) {
                this.holidayService.getHoliday(data.objectId).then((data) => {
                    this.currentHoliday = data;
                    this.currentHoliday.dateFrom = this.$qui.createDateFromString(data.dateFrom);
                    if (this.currentHoliday.dateFrom !== (null || undefined))
                        this.currentHoliday.dateTo = this.$qui.createDateFromString(data.dateTo);
                });
                $('#holidayComment').modal('toggle');
            }
            deleteHoliday(item) {
                this.calls.delete(item);
            }
            getWv() {
                this.holidayService.getHolidayWv().then((data) => {
                    // Create Filter selection
                    this.approvementMap = data.approvementWvList.map(x => ({ text: x.name, value: x.objectId }));
                    if (QMC.Common.personalLocalStorage.getItem(this.storageName))
                        this.filter.approvement = JSON.parse(QMC.Common.personalLocalStorage.getItem(this.storageName)).approvement;
                });
            }
        };
        HolidayListController = __decorate([
            QMC.Controller('QMC.Holiday', 'HolidayListController'),
            QMC.Inject('HolidayService', '$qui', '$scope', '$sce', '$stateParams', '$state', 'QmcLanguageService', 'UserService', 'QmcPermissionService', '$location')
        ], HolidayListController);
    })(Holiday = QMC.Holiday || (QMC.Holiday = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Holiday;
    (function (Holiday) {
        class HolidayFormDirective {
            constructor(scope, holidayService, $qui, lng, rosterService) {
                this.scope = scope;
                this.holidayService = holidayService;
                this.$qui = $qui;
                this.lng = lng;
                this.rosterService = rosterService;
                this.ui = new Holiday.UserInterface();
                this.wvList = {
                    id: undefined,
                    objectId: undefined,
                    approvementWvList: [],
                    holidayTypeWvList: [],
                    specialHolidayTypeWvList: []
                };
                this.calcedValues = { days: 0, hours: 0 };
                this.validation = {
                    isLoading: false,
                    errors: [],
                    warnings: []
                };
                this.pauseWatchers = false;
                this.id = '_' + Math.random().toString(36).substr(2, 9);
                this.promptOptions = {
                    title: "Urlaubsantrag",
                    yesNo: true,
                    icon: "qm-icon-history2",
                    text: this.lng.translate(20000290, 'Wollen Sie den Eintrag wirklich löschen?'),
                    itemText: ''
                };
                this.$postLink = () => {
                    this.calls = {
                        new: (form) => {
                            this.initForm();
                            this.formState = 'new';
                            this.lastValidation = undefined;
                            this.validation.errors = [];
                            this.validation.warnings = [];
                            if (form !== 'init') {
                                this.form = form !== null && form !== void 0 ? form : this.form;
                                if (this.wvList && this.wvList.holidayTypeWvList.length === 2)
                                    this.form.holidayTypeId = this.wvList.holidayTypeWvList[1].objectId;
                                this.calls.open();
                                this.refreshForm();
                            }
                            this.disabledIntern = !this.permissions.standard.new;
                        },
                        edit: (form, start, end) => {
                            var _a, _b;
                            this.formState = 'edit';
                            this.lastValidation = undefined;
                            this.validation.errors = [];
                            this.validation.warnings = [];
                            if (typeof form === 'string') {
                                this.loadHoliday(form, start, end);
                            }
                            else {
                                this.form = form !== null && form !== void 0 ? form : this.form;
                                this.pauseWatchers = true;
                                this.formatForm();
                                setTimeout(() => { this.pauseWatchers = false; this.validate(); }, 50);
                                this.disabledIntern = !((((_a = this.form) === null || _a === void 0 ? void 0 : _a.approvedId) === QMC.Common.Constants.APPROVAL_PENDING_ID || this.permissions.approved.openFile) && ((_b = this.form) === null || _b === void 0 ? void 0 : _b.permissions.modify));
                                if (start)
                                    this.form.dateFrom = start;
                                if (end)
                                    this.form.dateTo = end;
                                this.refreshForm();
                            }
                            this.calls.open();
                        },
                        delete: (form) => { this.deleteHoliday(form !== null && form !== void 0 ? form : this.form); },
                        open: () => {
                            $('#' + this.id).modal('show');
                            this.$qui.waitForEl('#standardTabButton', () => {
                                $('#standardTabButton').click();
                            });
                        },
                        close: () => { $('#' + this.id).modal('hide'); }
                    };
                };
                this.$onDestroy = () => {
                    $('#' + this.id).remove();
                };
                this.init();
                this.events();
            }
            getModalCaption() {
                var _a;
                let result = this.lng.translate(20020011, 'Urlaubsantrag');
                if ((_a = this.reference) === null || _a === void 0 ? void 0 : _a.name)
                    result = `${result} (${this.reference.name})`;
                return result;
            }
            formatForm() {
                if (this.form) {
                    this.form.approved = this.getApprovementWvItem(this.form.approvedId);
                    this.form.isManualDays = this.form.accountingTypeFlag === 0;
                    this.form.isManualHours = this.form.accountingTypeFlag === 1;
                    this.form.creditWorkAsHoliday = this.form.accountingTypeFlag === 2;
                    this.form.permissionApproved = this.permissions.approved.openFile;
                }
            }
            getColorFromWv() {
                var _a, _b;
                if (!this.wvList)
                    return;
                if (this.form && (!this.form.holidayTypeId || this.form.holidayTypeId === QMC.Common.Constants.GUID_EMPTY)) {
                    this.form.color = '#0000FF';
                    return;
                }
                let wvs = this.wvList.holidayTypeWvList;
                if (((_a = this.form) === null || _a === void 0 ? void 0 : _a.isSpecialHoliday) && ((_b = this.wvList) === null || _b === void 0 ? void 0 : _b.specialHolidayTypeWvList))
                    wvs = this.wvList.specialHolidayTypeWvList;
                //get integervalue
                for (const item of wvs) {
                    if (this.form.holidayTypeId === item.objectId) {
                        // convert argb color in wv to html color
                        this.form.color = '#' + ('000000' + (item.value & 0xFFFFFF).toString(16)).slice(-6);
                    }
                }
            }
            events() {
                this.scope.$watch('vm.form.holidayTypeId', () => {
                    this.getColorFromWv();
                });
                this.scope.$watch('vm.form.isManualDays', (newValue) => {
                    if (this.pauseWatchers || !newValue || !this.form)
                        return;
                    this.form.isManualHours = false;
                    this.form.creditWorkAsHoliday = false;
                    this.form.accountingTypeFlag = 0;
                });
                this.scope.$watch('vm.form.isManualHours', (newValue) => {
                    if (this.pauseWatchers || !newValue || !this.form)
                        return;
                    this.form.isManualDays = false;
                    this.form.creditWorkAsHoliday = false;
                    this.form.accountingTypeFlag = 1;
                });
                this.scope.$watch('vm.form.creditWorkAsHoliday', (newValue) => {
                    if (this.pauseWatchers || !newValue || !this.form)
                        return;
                    this.form.isManualDays = false;
                    this.form.isManualHours = false;
                    this.form.accountingTypeFlag = 2;
                });
                this.scope.$watch('vm.form.dateFrom', (newValue, oldValue) => {
                    if (!newValue)
                        return;
                    if (moment(newValue).format("L") === moment(oldValue).format("L"))
                        return;
                    this.getCalcDayValues();
                });
                this.scope.$watch('vm.form.dateTo', (newValue, oldValue) => {
                    if (!newValue)
                        return;
                    if (moment(newValue).format("L") === moment(oldValue).format("L"))
                        return;
                    this.getCalcDayValues();
                });
                this.scope.$watch('vm.form', (newValue, oldValue) => {
                    if (!newValue || JSON.stringify(newValue) === JSON.stringify(oldValue))
                        return;
                    if (!this.pauseWatchers) {
                        // make sure accountingType checkboxes work as Radio Boxes and set the flag
                        if (!newValue.isManualDays && !newValue.isManualHours && !newValue.creditWorkAsHoliday) { // there must always be one
                            if (oldValue) {
                                this.form.isManualDays = oldValue.isManualDays;
                                this.form.isManualHours = oldValue.isManualHours;
                                this.form.creditWorkAsHoliday = oldValue.creditWorkAsHoliday;
                            }
                            else
                                this.form.isManualDays = true;
                        }
                        if (this.form.isManualDays) {
                            this.form.accountingTypeFlag = 0;
                            this.form.amountOfHours = 0;
                            if (!(oldValue === null || oldValue === void 0 ? void 0 : oldValue.isManualDays))
                                this.form.amountOfDays = this.calcedValues.days;
                        }
                        if (this.form.isManualHours) {
                            this.form.accountingTypeFlag = 1;
                            this.form.amountOfDays = 0;
                            if (!(oldValue === null || oldValue === void 0 ? void 0 : oldValue.isManualHours))
                                this.form.amountOfHours = this.calcedValues.hours;
                        }
                        if (this.form.creditWorkAsHoliday) {
                            this.form.amountOfDays = 0;
                            this.form.amountOfHours = 0;
                            this.form.accountingTypeFlag = 2;
                        }
                        // validate
                        this.validate();
                    }
                    // set approved string
                    this.form.approved = this.getApprovementWvItem(this.form.approvedId);
                }, true);
            }
            ;
            init() {
                this.$qui.functionWaiter("ui.createForm", this);
                this.holidayService.getHolidayLock().then((lockDate) => {
                    this.lockDate = this.$qui.createDateFromString(lockDate);
                });
                this.holidayService.getHolidayWv().then((data) => {
                    this.wvList = data;
                    this.approvementList = this.ui.select(data.approvementWvList, { value: 'objectId', text: 'name' });
                });
                this.holidayService.getHolidayRequiredFields().then((data) => {
                    this.requiredFields = data;
                    this.applyRequiredFields();
                }).finally(() => this.$qui.functionWaiter("ui.createForm", this));
            }
            applyRequiredFields() {
                if (!this.requiredFields)
                    return;
                this.ui.holidayForm.form.forEach((field) => {
                    var _a;
                    if (field.model === 'holidayTypeId')
                        field.required = this.requiredFields.holidayTypeId;
                    if (field.model === 'comment')
                        field.required = this.requiredFields.comment;
                    if (field.type === 'DateRange') {
                        field.config = (_a = field.config) !== null && _a !== void 0 ? _a : {};
                        field.config.dateFromNotRequired = !this.requiredFields.dateFrom;
                        field.config.dateToRequired = this.requiredFields.dateTo;
                    }
                });
            }
            refreshForm() {
                this.applyRequiredFields();
                this.ui.createForm();
            }
            initForm() {
                var _a, _b, _c, _d;
                this.form = {
                    comment: "",
                    dateFrom: moment().startOf('day').toDate(),
                    dateTo: moment().endOf('day').toDate(),
                    holidayTypeId: null,
                    isSpecialHoliday: false,
                    color: '#0000FF',
                    amountOfDays: 1,
                    amountOfHours: 0,
                    accountingTypeFlag: 0,
                    isManualDays: true,
                    isManualHours: false,
                    creditWorkAsHoliday: false,
                    permissionApproved: (_b = (_a = this.permissions) === null || _a === void 0 ? void 0 : _a.approved) === null || _b === void 0 ? void 0 : _b.openFile,
                    approvedId: ((_d = (_c = this.permissions) === null || _c === void 0 ? void 0 : _c.approved) === null || _d === void 0 ? void 0 : _d.openFile) ? QMC.Common.Constants.APPROVAL_APRROVED_ID : QMC.Common.Constants.APPROVAL_PENDING_ID
                };
                this.getCalcDayValues();
                setTimeout(() => {
                    this.getColorFromWv();
                }, 50);
            }
            getHolidayCategoryList() {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                const result = [];
                if (((_b = (_a = this.permissions) === null || _a === void 0 ? void 0 : _a.standard) === null || _b === void 0 ? void 0 : _b.new) || ((_d = (_c = this.permissions) === null || _c === void 0 ? void 0 : _c.standard) === null || _d === void 0 ? void 0 : _d.modify))
                    result.push({ value: false, text: this.lng.translate(20020000, "Urlaub") });
                if (((_f = (_e = this.permissions) === null || _e === void 0 ? void 0 : _e.special) === null || _f === void 0 ? void 0 : _f.new) || ((_h = (_g = this.permissions) === null || _g === void 0 ? void 0 : _g.special) === null || _h === void 0 ? void 0 : _h.modify))
                    result.push({ value: true, text: this.lng.translate(20020019, "Sonderurlaub") });
                return result;
            }
            getHolidayTypeList() {
                return this.wvList.holidayTypeWvList.map((obj) => ({ value: obj.objectId, text: obj.name }));
            }
            getSpecialHolidayTypeList() {
                return this.wvList.specialHolidayTypeWvList.map((obj) => ({ value: obj.objectId, text: obj.name }));
            }
            getApprovementWvList() {
                return this.wvList.approvementWvList.map((obj) => ({ value: obj.objectId, text: obj.name }));
            }
            getApprovementWvItem(approvedId) {
                var _a, _b, _c, _d;
                const result = (_b = (_a = this.wvList) === null || _a === void 0 ? void 0 : _a.approvementWvList) === null || _b === void 0 ? void 0 : _b.filter(item => item.objectId === approvedId);
                return result ? (_d = (_c = result[0]) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : '' : '';
            }
            getCheckboxStatus() {
                if (this.form.isManualDays)
                    return 0;
                if (this.form.isManualHours)
                    return 1;
                if (this.form.creditWorkAsHoliday)
                    return 2;
            }
            getCalcDayValues() {
                var _a, _b;
                this.loadingDayCalc = true;
                this.scope.$evalAsync();
                this.holidayService.calculateDayValues(this.form.dateFrom, this.form.dateTo, (_b = (_a = this.reference) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : $('#session').data().personId).then((data) => {
                    this.calcedValues.days = data.calcDays;
                    this.calcedValues.hours = 0;
                    if (this.form.isManualDays)
                        this.form.amountOfDays = this.calcedValues.days;
                    if (this.form.isManualHours)
                        this.form.amountOfDays = this.calcedValues.hours;
                }).finally(() => {
                    this.loadingDayCalc = false;
                    this.scope.$evalAsync();
                });
            }
            validate() {
                var _a, _b;
                if (!this.form)
                    return;
                const validationForm = {
                    dateFrom: this.form.dateFrom,
                    dateTo: this.form.dateTo,
                    holidayId: this.form.objectId ? this.form.objectId : QMC.Common.Constants.GUID_EMPTY,
                    approvementTypeId: this.form.approvedId ? this.form.approvedId : QMC.Common.Constants.GUID_EMPTY,
                    isSpecialHoliday: this.form.isSpecialHoliday,
                    holidayTypeId: this.form.holidayTypeId,
                    calculationType: this.getCheckboxStatus(),
                    randomId: Math.random().toString(36).substr(2, 9),
                    dayCount: this.form.isManualDays ? this.form.amountOfDays : 0,
                    hourCount: this.form.isManualHours ? this.form.amountOfHours : 0,
                    referenceId: (_b = (_a = this.reference) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : $('#session').data().personId
                };
                if (this.lastValidation) {
                    const last = angular.copy(this.lastValidation);
                    const current = angular.copy(validationForm);
                    delete last.randomId;
                    delete current.randomId;
                    if (JSON.stringify(last) === JSON.stringify(current))
                        return;
                }
                this.lastValidation = validationForm;
                this.validation = {
                    warnings: [],
                    errors: [],
                    isLoading: true
                };
                let loading = 0;
                const finallyAction = () => {
                    loading++;
                    this.validation.isLoading = loading < 1;
                };
                const catchAction = () => {
                    this.validation.errors = [this.lng.translate(0, 'Es konnte nicht komplett validiert werden')];
                };
                const getAction = (data) => {
                    if (this.lastValidation.randomId === validationForm.randomId) {
                        if (data.warnings.length > 0)
                            this.validation.warnings = this.validation.warnings.concat(data.warnings);
                        if (data.errors.length > 0)
                            this.validation.errors = this.validation.errors.concat(data.errors);
                    }
                };
                this.holidayService.checkForWarningsAndErrors(validationForm).then((data) => {
                    getAction(data);
                    if (this.lastValidation.randomId === validationForm.randomId && this.lockDate && validationForm.dateFrom > this.lockDate) {
                        this.validation.warnings.push(this.lng.translate(20020012, "Sie können keinen Urlaubsantrag erstellen, der nach dem Sperrdatum liegt."));
                    }
                }).catch(catchAction).finally(finallyAction);
                //this.rosterService.validateNonService({
                //    entryId: this.form.objectId,
                //    referenceId: this.reference?.id ?? $('#session').data().personId,
                //    reference: this.reference?.name ?? '',
                //    dateFrom: this.form.dateFrom,
                //    dateTo: this.form.dateTo,
                //    serviceTypeId: '8bdf6a27-a881-4b4b-8abf-3bedb5156df2',
                //    serviceSubTypeId: this.form.serviceSubTypeId,
                //    randomId: Math.random().toString(36).substring(2, 11)
                //}).then((data) => getAction(data)).catch(catchAction).finally(finallyAction);
            }
            loadHoliday(id, start, end) {
                this.loading = true;
                this.holidayService.getHoliday(id).then((data) => {
                    this.pauseWatchers = true;
                    data.dateFrom = this.$qui.createDateFromString(data.dateFrom);
                    if (data.dateTo)
                        data.dateTo = this.$qui.createDateFromString(data.dateTo);
                    this.form = data;
                    this.formatForm();
                    this.disabledIntern = !((data.approvedId === QMC.Common.Constants.APPROVAL_PENDING_ID || this.permissions.approved.openFile) && data.permissions.modify);
                    if (start)
                        this.form.dateFrom = start;
                    if (end)
                        this.form.dateTo = end;
                    setTimeout(() => {
                        this.pauseWatchers = false;
                        this.loading = false;
                        this.validate();
                    }, 50);
                    this.refreshForm();
                });
            }
            putHoliday(form) {
                this.loading = true;
                if (this.validation.errors.length === 0 && !this.validation.isLoading && !this.loadingDayCalc) {
                    this.holidayService.putHoliday(form.id, form).then(() => {
                        var _a;
                        this.ui.notify(this.ui.successNote);
                        if ((_a = this.callbacks()) === null || _a === void 0 ? void 0 : _a.onEdit)
                            this.callbacks().onEdit(true);
                        this.calls.close();
                    }).catch(() => {
                        var _a;
                        if ((_a = this.callbacks()) === null || _a === void 0 ? void 0 : _a.onEdit)
                            this.callbacks().onEdit(false);
                    }).finally(() => this.loading = false);
                }
            }
            deleteHoliday(item) {
                this.loading = true;
                this.promptOptions.itemText = item.caption + " (" + moment(item.dateFrom).format("DD.MM.YYYY") + " - " + moment(item.dateTo).format("DD.MM.YYYY") + ")";
                QMC.Common.Utilities.confirm(this.promptOptions, (data) => {
                    if (data) {
                        this.holidayService.deleteHoliday(item.id).then(() => {
                            var _a;
                            this.ui.notify(this.ui.deleteNote);
                            this.calls.close();
                            if ((_a = this.callbacks()) === null || _a === void 0 ? void 0 : _a.onDelete)
                                this.callbacks().onDelete(true);
                        }).catch(() => {
                            var _a;
                            if ((_a = this.callbacks()) === null || _a === void 0 ? void 0 : _a.onDelete)
                                this.callbacks().onDelete(false);
                        }).finally(() => this.loading = false);
                    }
                }, `#${this.id}-prompt`);
            }
            addHoliday(form) {
                var _a, _b;
                this.loading = true;
                if (this.validation.errors.length === 0 && !this.validation.isLoading && !this.loadingDayCalc) {
                    this.form.referenceId = (_b = (_a = this.reference) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : $('#session').data().personId;
                    this.holidayService.postHoliday(form).then(() => {
                        var _a;
                        this.ui.notify(this.ui.successNote);
                        if ((_a = this.callbacks()) === null || _a === void 0 ? void 0 : _a.onNew)
                            this.callbacks().onNew(true);
                        this.calls.close();
                    }).catch(() => {
                        var _a;
                        if ((_a = this.callbacks()) === null || _a === void 0 ? void 0 : _a.onNew)
                            this.callbacks().onNew(false);
                    }).finally(() => this.loading = false);
                }
            }
        }
        angular.module('QMC.Holiday').component('qmHolidayForm', {
            templateUrl: './Holiday/FormDirective',
            controller: ['$scope', 'HolidayService', '$qui', 'QmcLanguageService', 'RosterService', HolidayFormDirective],
            controllerAs: 'vm',
            bindings: {
                form: '=?',
                permissions: '=',
                calls: '=',
                callbacks: '&',
                reference: '=',
            }
        });
    })(Holiday = QMC.Holiday || (QMC.Holiday = {}));
})(QMC || (QMC = {}));

//# sourceMappingURL=../../maps/Holiday/qmc.holiday.js.map
